import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=40aaa55d&"
import script from "./ActivityTab.vue?vue&type=script&lang=ts&"
export * from "./ActivityTab.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityTab.vue?vue&type=style&index=0&id=40aaa55d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports